import { UserId } from 'types';

export const ACTIVATION_EMAIL = (userId: UserId) => `/api/v1/auth/users/${userId}/activation-email`;
